import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { normalizeProduct } from '@b2b/features/product/core/utilities/product.normalizer';
import { map, Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { GetSuggestionsResponse, Suggestions } from '@b2b/features/product/core/utilities/suggestion.model';

@Injectable({
  providedIn: 'root',
})
export class SuggestionsService {
  private readonly apiUrl = `${environment.apiService || ''}/search/suggestions`;

  constructor(private http: HttpClient) {}

  suggestionsProducts(searchTerm: string): Observable<Suggestions> {
    return this.http.get<GetSuggestionsResponse>(`${this.apiUrl}/${searchTerm}`).pipe(
      map(response => ({
        ...response,
        products: normalizeProduct(response.products),
      })),
    );
  }
}
